<template>
  <a-row class="content-fix" type="flex">
    <spinner v-if="loading" />
    <a-col v-show="!loading" class="height100 flex-1" style="padding-top: 30px">
      <a-row
        v-for="field in fields"
        :key="field.key"
        align="middle"
        :class="{ 'form-group--error': errors[field.key] }"
        class="form-group flex-baseline"
      >
        <a-col :span="4" class="form_title">
          <label>{{ $t(field.label) }}</label>
        </a-col>

        <a-col :span="12" class="sm-mb">
          <!-- TEXT -->
          <a-input
            v-if="field.type === 'text'"
            v-model="form[field.key]"
            :placeholder="$t(field.placeholder)"
          />

          <!-- DATE -->
          <a-input
            v-else-if="field.type === 'date'"
            v-model="form[field.key]"
            type="date"
            class="input-date"
          />

          <!-- QUARTER SELECT -->
          <a-select
            v-else-if="field.type === 'select' && field.key === 'quarter'"
            v-model="form[field.key]"
            style="width: 100%"
            :disabled="form.period_type === 'annual'"
          >
            <a-select-option
              v-for="option in field.options"
              :key="option.value"
              :value="option.value"
            >
              {{ $t(option.label) }}
            </a-select-option>
          </a-select>

          <!-- GENERIC SELECT -->
          <a-select
            v-else-if="field.type === 'select'"
            v-model="form[field.key]"
            style="width: 100%"
          >
            <a-select-option
              v-for="option in field.options"
              :key="option.value"
              :value="option.value"
            >
              {{ $t(option.label) }}
            </a-select-option>
          </a-select>

          <!-- FILE UPLOAD -->
          <a-row v-else-if="field.type === 'file'" class="flex-baseline">
            <a-col :span="12">
              <a-button type="primary" @click="triggerFileInput">
                <a-icon type="upload" /> Upload New File
              </a-button>

              <input
                ref="documentRef"
                accept=".xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf"
                hidden
                type="file"
                @change="handleDocumentInput"
              />

              <!-- Existing File -->
              <div v-if="existingFile" style="margin-top: 10px">
                <strong>Current File:</strong>
                <a :href="existingFile" target="_blank">{{ existingFile }}</a>
              </div>

              <!-- New Selected File -->
              <div v-if="fileName" style="margin-top: 10px">
                <strong>Selected File:</strong> {{ fileName }}
              </div>

              <a-button
                v-if="existingFile"
                style="margin-top: 10px"
                type="danger"
                @click="removeExistingFile"
              >
                <a-icon type="delete" /> Remove Existing File
              </a-button>
            </a-col>
          </a-row>

          <!-- SWITCH -->
          <a-switch
            v-else-if="field.type === 'switch'"
            v-model="form[field.key]"
          />
        </a-col>
      </a-row>

      <!-- ACTION BUTTONS -->
      <a-row class="form-buttons__action" type="flex">
        <a-col :span="3" class="form_title" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />Отмена
          </a-button>

          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submit()"
          >
            <a-icon type="check" />
            Сохранить
          </a-button>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  name: "EditCertificate",

  data() {
    return {
      fileName: "",
      existingFile: null,
      form: {
        title: "",
        year_id: null,
        period_type: "",
        publication_date: "",
        is_published: false,
        data_file: null,
        quarter: null
      },
      fields: [
        {
          key: "title",
          label: "TableTitle",
          type: "text",
          placeholder: "TableTitle"
        },
        {
          key: "period_type",
          label: "PeriodType",
          type: "select",
          options: [
            { value: "annual", label: "Annual" },
            { value: "quarterly", label: "Quarterly" }
          ]
        },
        { key: "publication_date", label: "PublicationDate", type: "date" },
        { key: "is_published", label: "Status", type: "switch" },
        {
          key: "quarter",
          label: "FormQuarter",
          type: "select",
          options: [
            { value: 1, label: "quarter1" },
            { value: 2, label: "quarter2" },
            { value: 3, label: "quarter3" },
            { value: 4, label: "quarter4" }
          ]
        },
        { key: "file", type: "file", label: "File" }
      ],
      errors: {},
      pending: false,
      loading: true,
      id: null
    }
  },

  computed: {
    ...mapGetters({
      years: "mtms/getYears",
      generalDetail: "mtms/generalDetail"
    })
  },

  watch: {
    "form.period_type"(v) {
      if (v === "annual") this.form.quarter = null
    },
    generalDetail: {
      handler(newVal) {
        if (newVal) {
          this.form.title = newVal.data.title
          this.form.year_id = newVal.data.year_id
          this.form.period_type = newVal.data.period_type
          this.form.publication_date = newVal.data.publication_date
          this.form.is_published = newVal.data.is_published
          this.form.quarter = newVal.data.quarter

          if (newVal.data.data_file) {
            this.existingFile = newVal.data.data_file
          }
        }
      }
    }
  },

  async created() {
    this.loading = true
    this.id = this.$route.params.id
    await this.fetchGeneralDetail(this.id)
    this.loading = false
  },

  methods: {
    ...mapActions({
      fetchGeneralDetail: "mtms/fetchGeneralDetail",
      fetchYears: "mtms/fetchYears"
    }),

    triggerFileInput() {
      this.$refs.documentRef.click()
    },

    removeExistingFile() {
      this.existingFile = null
      this.form.data_file = null
    },

    handleDocumentInput(e) {
      const file = e.target.files[0]
      if (!file) return

      this.form.data_file = file
      this.fileName = file.name

      this.$refs.documentRef.value = ""
    },

    async submit() {
      try {
        this.pending = true

        await this.fetchYears()
        const selectedYear = Number(this.$route.params.year)

        for (const item of this.years.data) {
          if (item.year === selectedYear) {
            this.form.year_id = item.id
            break
          }
        }

        const fd = new FormData()
        for (const key in this.form) {
          const value = this.form[key]
          if (value === null || value === undefined) continue

          if (value instanceof File) {
            fd.append(key, value)
          } else if (typeof value === "boolean") {
            fd.append(key, value) // raw boolean
          } else {
            fd.append(key, String(value))
          }
        }

        const response = await this.$api.put(
          `/admin/common/general-statistics/${this.id}`,
          fd,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        )

        const { data } = response

        if (data) {
          this.$message.success("Successfully updated")
          this.$router.go(-1)
        } else {
          this.$message.warning("Failed to update")
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.pending = false
      }
    }
  }
}
</script>

<style scoped>
.content-fix {
  padding: 20px;
  border-radius: 8px;
}

.form_title {
  font-weight: bold;
}

.input-date {
  width: 100%;
  max-width: 300px;
}

.form-group {
  margin-bottom: 15px;
}

.form-buttons__action {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
